import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FaChartBar,
  FaBalanceScale,
  FaReceipt,
  FaMoneyBillWave,
  FaHandshake,
  FaFileInvoiceDollar,
  FaArrowLeft,
  FaCreditCard,
  FaCheckDouble,
  FaUserTie,
  FaUserCog,
  FaBook,
  FaFileAlt,
  FaClipboardList,
  FaExchangeAlt,
} from "react-icons/fa";
import { useRole } from "../context/RoleContext";

export const FINANCE_MENU_ITEMS = [
  {
    id: "chart-accounts",
    title: "CHART OF ACCOUNTS MENU",
    icon: FaChartBar,
    path: "/chart-of-accounts",
    group: "Reports",
    description: "View and manage chart of accounts",
  },
  {
    id: "trial-balance",
    title: "TRIAL BALANCE - DETAIL BALANCE",
    icon: FaBalanceScale,
    path: "/trial-balance",
    group: "Reports",
    description: "Detailed trial balance for a date range",
  },
  {
    id: "finance-statements",
    title: "FINANCE STATEMENTS",
    icon: FaCreditCard,
    path: "/finance-statements",
    group: "Reports",
    description: "Income statement and balance sheet",
  },
  {
    id: "hst-report",
    title: "HST REPORT",
    icon: FaReceipt,
    path: "/hst-report",
    group: "Reports",
    description: "HST collected and input tax credit",
  },
  {
    id: "activity-details-report",
    title: "ACTIVITY DETAILS REPORT",
    icon: FaClipboardList,
    path: "/finance-activity-details",
    group: "Reports",
    description: "Commission activity by G/L account",
  },
  {
    id: "open-trades-commission-report",
    title: "OPEN TRADES COMMISSION REPORT",
    icon: FaChartBar,
    path: "/finance-open-trades-commission",
    group: "Reports",
    description: "Commission for trades opened in a period",
  },
  {
    id: "commission-report",
    title: "COMMISSION REPORT",
    icon: FaChartBar,
    path: "/finance-commission-report",
    group: "Reports",
    description: "Commission by agent and classification",
  },
  {
    id: "pending-trade-report",
    title: "PENDING TRADE REPORT",
    icon: FaClipboardList,
    path: "/finance-pending-trade-report",
    group: "Reports",
    description: "Pending listing and selling ends",
  },
  {
    id: "custom-report",
    title: "CUSTOM REPORT",
    icon: FaClipboardList,
    path: "/finance-custom-report",
    group: "Reports",
    description: "Editable trade report by closing-date period",
  },
  {
    id: "invoice-detail-report",
    title: "INVOICE DETAIL REPORT",
    icon: FaClipboardList,
    path: "/finance-invoice-detail-report",
    group: "Reports",
    description: "Monthly invoice detail by entry date",
  },
  {
    id: "agent-payment-summary",
    title: "AGENT SUMMARY REPORT",
    icon: FaUserCog,
    path: "/agent-payment-summary",
    group: "Reports",
    description: "Agent payment summary report",
  },
  {
    id: "journal-entry",
    title: "JOURNAL ENTRY",
    icon: FaBook,
    path: "/journal-entry",
    group: "Journals",
    description: "Create and review journal entries",
  },
  {
    id: "disbursements-journals",
    title: "DISBURSEMENTS JOURNALS",
    icon: FaFileAlt,
    path: "/disbursements-journals",
    group: "Journals",
    description: "Disbursement journal activity",
  },
  {
    id: "trust-journal",
    title: "TRUST JOURNAL",
    icon: FaBook,
    path: "/trust-journal",
    group: "Journals",
    description: "Real estate trust journal",
  },
  {
    id: "trade-ar-journal",
    title: "TRADE A/R JOURNAL",
    icon: FaBook,
    path: "/trade-ar-journal",
    group: "Journals",
    description: "Trade accounts receivable journal",
  },
  {
    id: "trust-payments",
    title: "REAL ESTATE TRUST PAYMENTS",
    icon: FaMoneyBillWave,
    path: "/real-estate-trust-payments",
    group: "Trust & Payments",
    description: "Issue real estate trust payments",
  },
  {
    id: "real-estate-trust-ledger",
    title: "REAL ESTATE TRUST LEDGER",
    icon: FaBook,
    path: "/real-estate-trust-ledger",
    group: "Trust & Payments",
    description: "Real estate trust ledger",
  },
  {
    id: "commission-trust",
    title: "COMMISSION TRUST PAYMENTS",
    icon: FaHandshake,
    path: "/commission-trust-payments",
    group: "Trust & Payments",
    description: "Issue commission trust payments",
  },
  {
    id: "commission-trust-ledger",
    title: "COMMISSION TRUST LEDGER",
    icon: FaBook,
    path: "/commission-trust-ledger",
    group: "Trust & Payments",
    description: "Commission trust ledger",
  },
  {
    id: "agent-expenses",
    title: "AGENT EXPENSES",
    icon: FaUserTie,
    path: "/agent-expenses",
    group: "Trust & Payments",
    description: "Record and review agent expenses",
  },
  {
    id: "general-account",
    title: "GENERAL ACCOUNT PAYMENTS (A/P) EXPENSES",
    icon: FaFileInvoiceDollar,
    path: "/general-account-payments",
    group: "Trust & Payments",
    description: "General account A/P expenses",
  },
  {
    id: "accounts-receivable",
    title: "ACCOUNTS RECEIVABLE",
    icon: FaUserTie,
    path: "/accounts-receivable",
    group: "Trust & Payments",
    description: "Trade accounts receivable",
  },
  {
    id: "agent-payment-info",
    title: "AGENT PAYMENT INFO",
    icon: FaUserCog,
    path: "/agent-payment-info",
    group: "Trust & Payments",
    description: "Agent payment details",
  },
  {
    id: "payroll-eft-reports",
    title: "EFT REPORTS",
    icon: FaFileInvoiceDollar,
    path: null,
    action: "eft-report-picker",
    group: "Payroll",
    description: "Agent Summary or Total Details for the year",
  },
  {
    id: "payroll-t4a",
    title: "T4A",
    icon: FaFileAlt,
    path: "/payroll/t4a",
    group: "Payroll",
    description: "T4A slip",
  },
  {
    id: "payroll-t4a-summary",
    title: "T4A SUMMARY",
    icon: FaClipboardList,
    path: "/payroll/t4a-summary",
    group: "Payroll",
    description: "T4A summary (office only)",
    officeOnly: true,
  },
  {
    id: "reconcile-real-estate-trust",
    title: "RECONCILING REAL ESTATE TRUST",
    icon: FaCheckDouble,
    path: "/reconcile-real-estate-trust",
    group: "Reconciling",
    description: "Reconcile the real estate trust account",
  },
  {
    id: "reconcile-commission-trust",
    title: "RECONCILING COMMISSION TRUST",
    icon: FaCheckDouble,
    path: "/reconcile-commission-trust",
    group: "Reconciling",
    description: "Reconcile the commission trust account",
  },
  {
    id: "reconcile-general-account",
    title: "RECONCILING GENERAL ACCOUNT",
    icon: FaCheckDouble,
    path: "/reconcile-general-account",
    group: "Reconciling",
    description: "Reconcile the general account",
  },
  {
    id: "eft-reversal",
    title: "EFT REVERSAL",
    icon: FaExchangeAlt,
    path: "/eft-reversal",
    group: "Reconciling",
    description: "Reverse an EFT payment",
  },
];

const FinanceSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isFinance } = useRole();

  if (isFinance) return null;

  const handleSidebarItemClick = (path) => {
    navigate(path);
  };

  const isActivePage = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="w-64 bg-white shadow-md h-full flex-shrink-0 flex flex-col overflow-hidden">
      <div className="p-4 border-b border-gray-200 flex-shrink-0">
        <button
          onClick={() => navigate("/finance")}
          className="flex items-center text-gray-600 hover:text-gray-800"
        >
          <FaArrowLeft className="mr-2" />
          Back to Finance
        </button>
      </div>
      <nav className="p-4 flex-1 overflow-y-auto">
        <ul className="space-y-2">
          {FINANCE_MENU_ITEMS.map((item) => (
            <li key={item.id}>
              <button
                onClick={() => handleSidebarItemClick(item.path)}
                className={`w-full text-left p-3 rounded-lg transition-colors ${
                  isActivePage(item.path)
                    ? "bg-blue-100 text-blue-700"
                    : "text-gray-600 hover:bg-gray-100"
                }`}
              >
                <div className="flex items-center">
                  <item.icon className="mr-2 text-sm flex-shrink-0" />
                  <span className="text-xs font-medium leading-snug">{item.title}</span>
                </div>
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default FinanceSidebar;
